import styled from 'styled-components/macro';
import { mobile } from "../theme";

export default styled.div`
  width: 1024px;
  min-height: 1000px;
  padding: 16px 16px 48px 48px;
  text-align: justify;
  word-break: break-word;
  position: relative;
  padding-top: calc(${p => p.theme.spacing} * 2);

  &::selection, *::selection {
    background: rgba(${p => p.theme.color.primary}, 0.99);
    color: rgba(${p => p.theme.color.light}, 1);
  }

  ${mobile`
    width: 100%;
    padding: 16px;
  `}
`